import { Injectable } from '@angular/core';
import {
  Router, Resolve
}                                 from '@angular/router';
import { DataService } from 'app/data.service';
import { Observable, of, EMPTY }  from 'rxjs';
import { mergeMap, take }         from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MunicipalityResolverService implements Resolve<any>{

  constructor( private neproseService: DataService, private router: Router) { }

  resolve(): Observable<any> | Observable<never>{
    return this.neproseService.municipalities().pipe(
      take(1),
      mergeMap(data=> {
        if (data) {
          return of(data);
        } else {
          this.router.navigate(['']);
        }
      })
    )
  }

}
